module.exports = __webpack_public_path__ + "assets/img/upload-btn.8bfdf67e.png";